var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-avatar-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMultiplayer),expression:"isMultiplayer"}],staticClass:"container"},[_vm._l((_vm.players),function(item){return [_c('Avatar',{key:item.id,attrs:{"badgeBackgroundColor":item.color,"imgSrc":item.avatar,"userName":item.name,"id":item.id}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }